'use client';

import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { type ComponentPropsWithRef } from 'react';

import s from './Radio.module.css';

export interface RadioProps extends ComponentPropsWithRef<'input'> {
  ariaDisabled?: boolean;
  className?: string;
  disabled?: boolean;
  id: string;
  name: string;
  value: string;
}

export const radioVariants = cva(s.radio);

export const Radio = (props: RadioProps) => {
  const { ariaDisabled, className, disabled = false, ...attrs } = props;

  const appearsDisabled = ariaDisabled || disabled ? true : undefined;

  return (
    <input
      aria-disabled={appearsDisabled}
      className={clsx(
        radioVariants({
          className,
        }),
      )}
      disabled={disabled}
      type="radio"
      {...attrs}
    />
  );
};
